module.exports = __webpack_public_path__ + "static/media/EUATC-Network.0af1e3b4.jpg";